export const vi = {
  roles: {
    title: 'Vai trò & phân quyền',
    description: 'Vai trò quyết định người dùng được làm gì và thấy dữ liệu nào.',
    add: 'Thêm vai trò',
    name: 'Tên vai trò',
    descriptionLabel: 'Mô tả',
    permissions: 'Quyền',
    members: 'Thành viên',
    default: 'Mặc định',
    system: 'Hệ thống',
    everyone: 'Mọi người dùng',
    search: 'Tìm vai trò…',
    columns: 'Cột',
    export: 'Xuất CSV',
    selected: 'Đã chọn {{count}}',
    empty: 'Chưa có vai trò',
    loadError: 'Không tải được dữ liệu',
    retry: 'Thử lại',
    save: 'Lưu',
    cancel: 'Huỷ',
    delete: 'Xoá vai trò',
    deleteConfirm:
      'Xoá vai trò {{name}}? Người dùng đang có vai trò này sẽ mất các quyền tương ứng.',
    saved: 'Đã lưu',
    back: 'Tất cả vai trò',
    defaultHint:
      'Vai trò này tự động áp dụng cho mọi người dùng đang hoạt động; không cần thêm thành viên.',
    adminHint: 'Quản trị hệ thống luôn có toàn bộ quyền, không phụ thuộc vai trò.',
    unsaved: 'Có thay đổi chưa lưu',
    addMember: 'Thêm thành viên',
    pickUser: 'Chọn người dùng…',
    removeMember: 'Gỡ',
    noMembers: 'Chưa có thành viên',
    scope: 'Phạm vi',
    edit: 'Sửa',
  },
  scopes: {
    own: 'Của bản thân',
    department: 'Đơn vị của tôi',
    department_tree: 'Đơn vị của tôi và cấp dưới',
    tenant: 'Toàn công ty',
  },
  errors: {
    'core-access': {
      system_role: 'Không thể xoá vai trò hệ thống.',
      duplicate_name: 'Đã có vai trò cùng tên.',
      default_role: 'Vai trò mặc định áp dụng cho mọi người, không cần thêm thành viên.',
    },
    generic: 'Thao tác không thành công. Vui lòng thử lại.',
  },
};

export const en: typeof vi = {
  roles: {
    title: 'Roles & permissions',
    description: 'Roles decide what users can do and which data they see.',
    add: 'Add role',
    name: 'Role name',
    descriptionLabel: 'Description',
    permissions: 'Permissions',
    members: 'Members',
    default: 'Default',
    system: 'System',
    everyone: 'Everyone',
    search: 'Search roles…',
    columns: 'Columns',
    export: 'Export CSV',
    selected: '{{count}} selected',
    empty: 'No roles yet',
    loadError: 'Could not load data',
    retry: 'Retry',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete role',
    deleteConfirm: 'Delete role {{name}}? Users with this role lose its permissions.',
    saved: 'Saved',
    back: 'All roles',
    defaultHint: 'This role applies to every active user automatically; no members needed.',
    adminHint: 'System administrators always hold every permission, regardless of roles.',
    unsaved: 'Unsaved changes',
    addMember: 'Add member',
    pickUser: 'Pick a user…',
    removeMember: 'Remove',
    noMembers: 'No members yet',
    scope: 'Scope',
    edit: 'Edit',
  },
  scopes: {
    own: 'Own records',
    department: 'My units',
    department_tree: 'My units and below',
    tenant: 'Whole company',
  },
  errors: {
    'core-access': {
      system_role: 'System roles cannot be deleted.',
      duplicate_name: 'A role with this name already exists.',
      default_role: 'The default role applies to everyone; no members needed.',
    },
    generic: 'The action failed. Please try again.',
  },
};
